import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { editSettingsGroup } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

const useSaveSettings = (
  handleClose: () => void,
  startYearClosure: () => void
) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'yearClosure.yearEndSettings'
  });
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(editSettingsGroup, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['yearClosure', 'list']
      });
      await queryClient.invalidateQueries({
        queryKey: ['year-end-procedure']
      });
      startYearClosure();
      handleClose();
    },
    onError: () => {
      showSnackbar({ severity: 'error', message: t('saveError') });
    }
  });

  return { mutate, isLoading };
};

export default useSaveSettings;
